import { CalculatorsData } from "./types";

export const data: CalculatorsData = {
  flat: {
    kits: [
      {
        name: "Default",
        subscription_min: 790,
        vendors: [
          {
            name: "C.Nord",
            kit_image: "/local/templates/Leggis/assets/images/cnord.png",
            image_width: 639,
            image_height: 335,
            image: "/local/templates/Leggis/assets/images/nord.png",
            base_cost: 16570,
            base_text: "Контрольная панель, Датчик движения, Датчик открытия",
            setup: 300,
            setup_base: 0,
            products: [
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_движения_СН-ИК-Мини.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик движения",
                price: 3290,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_открытия_СН-СМК-Мини.png",
                image_width: 128,
                image_height: 85,
                name: "Датчик открытия",
                price: 2290,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Детектор_дыма_СН-Дым.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик дыма",
                price: 3990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_протечки_воды.jpeg",
                image_width: 1000,
                image_height: 910,
                name: "Датчик протечки воды",
                price: 4090,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Тревожная кнопка, носимая",
                price: 2490, // TODO: check
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Тревожная_кнопка_носимая_и_стационарная.jpeg",
                image_width: 400,
                image_height: 400,
                name: "Тревожная кнопка, стационарная",
                price: 500,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Брелок управления",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
            ],
            options: [
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Реагирование ОВО",
                prefix: "от ",
                subscription: 100,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Техническое обслуживание системы",
                subscription: 200,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "СМС-оповещение",
                subscription: 100,
                type: "count",
                included: 1,
                initial: 1,
                min: 1,
                max: 6,
                description: "",
              },
            ],
          },
        ],
        options: [
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Реагирование ОВО",
            prefix: "от ",
            subscription: 100,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Техническое обслуживание системы",
            subscription: 200,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "СМС-оповещение",
            subscription: 100,
            type: "count",
            included: 1,
            initial: 1,
            min: 1,
            max: 6,
            description: "",
          },
        ],
      },
    ],
  },
  house: {
    kits: [
      {
        name: "Default",
        subscription_min: 1990,
        vendors: [
          {
            name: "C.Nord",
            kit_image: "/local/templates/Leggis/assets/images/cnord_house.png",
            image_width: 639,
            image_height: 335,
            image: "/local/templates/Leggis/assets/images/nord.png",
            base_cost: 24970,
            base_text:
              "Контрольная панель, Клавиатура, Датчик движения, Датчик открытия",
            setup: 300,
            setup_base: 0,
            products: [
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_движения_СН-ИК-Мини.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик движения",
                price: 3990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/sn-ik-street.jpg",
                image_width: 390,
                image_height: 582,
                name: "Датчик движения уличный",
                price: 8990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_открытия_СН-СМК-Мини.png",
                image_width: 128,
                image_height: 85,
                name: "Датчик открытия",
                price: 2290,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Детектор_дыма_СН-Дым.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик дыма",
                price: 3990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_протечки_воды.jpeg",
                image_width: 1000,
                image_height: 910,
                name: "Датчик протечки воды",
                price: 4090,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Тревожная кнопка, носимая",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Тревожная_кнопка_носимая_и_стационарная.jpeg",
                image_width: 400,
                image_height: 400,
                name: "Тревожная кнопка, стационарная",
                price: 500,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Брелок управления",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
            ],
            options: [
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Реагирование ОВО",
                prefix: "от ",
                subscription: 100,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Техническое обслуживание системы",
                subscription: 200,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "СМС-оповещение",
                subscription: 100,
                type: "count",
                included: 1,
                initial: 1,
                min: 1,
                max: 6,
                description: "",
              },
            ],
          },
        ],
        options: [
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Реагирование ОВО",
            prefix: "от ",
            subscription: 1000,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Техническое обслуживание системы",
            subscription: 300,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "СМС-оповещение",
            subscription: 100,
            type: "count",
            included: 1,
            initial: 1,
            min: 1,
            max: 6,
            description: "",
          },
        ],
      },
    ],
  },
  business: {
    kits: [
      {
        name: "Тревожная кнопка",
        subscription_min: 3490,
        vendors: [
          {
            name: "C.Nord",
            kit_image:
              "/local/templates/Leggis/assets/images/kits/тревожная кнопка cnord.png",
            image_width: 639,
            image_height:335,
            image: "/local/templates/Leggis/assets/images/nord.png",
            base_cost: 7500,
            base_text: "Контрольная панель, Кнопка тревожная стационарная",
            setup: 300,
            setup_base: 0,
            products: [
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Тревожная кнопка, носимая",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Тревожная_кнопка_носимая_и_стационарная.jpeg",
                image_width: 400,
                image_height: 400,
                name: "Тревожная кнопка, стационарная",
                price: 500,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
            ],
            options: [
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Реагирование ОВО",
                prefix: "от ",
                subscription: 100,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Техническое обслуживание системы",
                subscription: 200,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "СМС-оповещение",
                subscription: 100,
                type: "count",
                included: 1,
                initial: 1,
                min: 1,
                max: 6,
                description: "",
              },
            ],
          },
        ],
        options: [
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Реагирование ОВО",
            prefix: "от ",
            subscription: 2500,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Техническое обслуживание системы",
            subscription: 0,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "СМС-оповещение",
            subscription: 100,
            type: "count",
            included: 1,
            initial: 1,
            min: 1,
            max: 6,
            description: "",
          },
        ],
      },
      {
        name: "Охранная сигнализация",
        subscription_min: 3490,
        vendors: [
          {
            name: "C.Nord",
            kit_image: "/local/templates/Leggis/assets/images/cnord.png",
            image_width: 639,
            image_height: 335,
            image: "/local/templates/Leggis/assets/images/nord.png",
            base_cost: 16570,
            base_text: "Контрольная панель, Датчик движения, Датчик открытия",
            setup: 300,
            setup_base: 0,
            products: [
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_движения_СН-ИК-Мини.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик движения",
                price: 3290,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_открытия_СН-СМК-Мини.png",
                image_width: 128,
                image_height: 85,
                name: "Датчик открытия",
                price: 2290,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Детектор_дыма_СН-Дым.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик дыма",
                price: 3990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_протечки_воды.jpeg",
                image_width: 1000,
                image_height: 910,
                name: "Датчик протечки воды",
                price: 4090,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Тревожная кнопка, носимая",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Тревожная_кнопка_носимая_и_стационарная.jpeg",
                image_width: 400,
                image_height: 400,
                name: "Тревожная кнопка, стационарная",
                price: 500,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Брелок управления",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
            ],
            options: [
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Реагирование ОВО",
                prefix: "от ",
                subscription: 100,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Техническое обслуживание системы",
                subscription: 200,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "СМС-оповещение",
                subscription: 100,
                type: "count",
                included: 1,
                initial: 1,
                min: 1,
                max: 6,
                description: "",
              },
            ],
          },
        ],
        options: [
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Реагирование ОВО",
            prefix: "от ",
            subscription: 2500,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Техническое обслуживание системы",
            subscription: 0,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "СМС-оповещение",
            subscription: 100,
            type: "count",
            included: 1,
            initial: 1,
            min: 1,
            max: 6,
            description: "",
          },
        ],
      },
      {
        name: "Охранная сигнализация + тревожная кнопка",
        subscription_min: 3490,
        vendors: [
          {
            name: "C.Nord",
            kit_image:
              "/local/templates/Leggis/assets/images/kits/охранная сигнализация cnord.png",
            image_width: 639,
            image_height:335,
            image: "/local/templates/Leggis/assets/images/nord.png",
            base_cost: 19070,
            base_text:
              "Контрольная панель, Клавиатура, Датчик движения, Датчик открытия, Тревожная кнопка, носимая",
            setup: 300,
            setup_base: 0,
            products: [
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_движения_СН-ИК-Мини.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик движения",
                price: 3290,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/sn-ik-street.jpg",
                image_width: 390,
                image_height: 582,
                name: "Датчик движения уличный",
                price: 8990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_открытия_СН-СМК-Мини.png",
                image_width: 128,
                image_height: 85,
                name: "Датчик открытия",
                price: 2990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Детектор_дыма_СН-Дым.png",
                image_width: 128,
                image_height: 96,
                name: "Датчик дыма",
                price: 3990,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Датчик_протечки_воды.jpeg",
                image_width: 1000,
                image_height: 910,
                name: "Датчик протечки воды",
                price: 4090,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Тревожная кнопка, носимая",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Тревожная_кнопка_носимая_и_стационарная.jpeg",
                image_width: 400,
                image_height: 400,
                name: "Тревожная кнопка, стационарная",
                price: 500,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
              {
                image:
                  "/local/templates/Leggis/assets/images/Брелок_управления_СН-Брелок.png",
                image_width: 128,
                image_height: 85,
                name: "Брелок управления",
                price: 2490,
                subscription: 0,
                count: 1,
                min: 0,
                max: 0,
                initial: 0,
                included: 0,
                description: "",
              },
            ],
            options: [
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Реагирование ОВО",
                prefix: "от ",
                subscription: 100,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "Техническое обслуживание системы",
                subscription: 200,
                type: "toggle",
                description: "",
              },
              {
                image: "/local/templates/Leggis/assets/images/product5.png",
                name: "СМС-оповещение",
                subscription: 100,
                type: "count",
                included: 1,
                initial: 1,
                min: 1,
                max: 6,
                description: "",
              },
            ],
          },
        ],
        options: [
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Реагирование ОВО",
            prefix: "от ",
            subscription: 2500,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "Техническое обслуживание системы",
            subscription: 0,
            type: "toggle",
            description: "",
          },
          {
            image: "/local/templates/Leggis/assets/images/product5.png",
            name: "СМС-оповещение",
            subscription: 100,
            type: "count",
            included: 1,
            initial: 1,
            min: 1,
            max: 6,
            description: "",
          },
        ],
      },
    ],
  },
};
